import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";
import { GRADE, MODULE, SUB_MODULE } from "../consts";
import { useGetCurriculumGrades } from "@/services/masterData/useGetCurriculumGrades";
import { useGetModules, useGetSubModules } from "@/services/masterData";

const useFilter = ({
  filterData,
  setFilterData,
  onCancel,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();
  const {
      data: gradesRes,
      isPending: isGradesLoading,
      error: gradesError,
    } = useGetCurriculumGrades();

    const {
        data: modulesRes,
        isPending: isModulesLoading,
        error: modulesError,
      } = useGetModules();
      

    const moduleOptions = (modulesRes?.data?.[0]?.records || []).map(
    (m: any) => ({
      label: m?.module_name,
      value: String(m?.module_id),
    })
  );
  
    const gradeOptions = (gradesRes?.data || []).map((g: any) => ({
      label: g?.curriculum_grade,
      value: String(g?.curriculum_id),
    }));

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [GRADE]: "",
      [MODULE]: "",
      [SUB_MODULE]: "",
    },
  });

  useEffect(() => {
    if (filterData) {
      form.reset({
        [GRADE]: filterData?.[GRADE] || "",
        [MODULE]: filterData?.[MODULE] || "",
        [SUB_MODULE]: filterData?.[SUB_MODULE] || "",
      });
    }
  }, [filterData]);

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(data);
    setFilterData(_data);
    onCancel();
  };

  const onClear = () => {
    form.reset({
        [GRADE]: "",
        [MODULE]: "",
      });
    setFilterData(null);
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
    gradeOptions,
    moduleOptions
  };
};

export default useFilter;
